import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConstants } from "../constants/apiConstants";
import axiosApi from "../api/axiosAPI";
import { authenticateWithPasskey, getPasskeyApiError, normalizeLoginSession } from "../../services/passkeyService";



//Login user
export const loginUser = createAsyncThunk(
    "loginApi/loginUser",
    async (formBody, { dispatch }) => {
        const params = {
            user_name: formBody.user_name,
            password: formBody.password,
        };

        try {
            const resp = await axiosApi.post(apiConstants.login?.userSignIn, params);
            const data = normalizeLoginSession(resp.data) || resp.data;
            dispatch(setLoginDetails(data));
            dispatch(setMenuItem(data.menu_items || data.Table1 || []));
            dispatch(setFamilyAccounts(data.family_accounts || data.Table2 || []));
            dispatch(setToken(data.Token || data.token));
            console.log(data, "dataannouncements");
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//Sign up user
export const userSignUp = createAsyncThunk(
    "loginApi/signUp",
    async (formBody, { dispatch }) => {
        const params = {
            first_name: formBody.firstName,
            last_name: formBody.lastName,
            gender_id: formBody.gender,
            user_name: formBody.email,
            email_address: formBody.email,
            password: formBody.password,
            dob: formBody.dob,
            phone_number: formBody.phone_number,
            usertype_id: formBody.usertype_id,
        };
        try {
            const resp = await axiosApi.post(apiConstants.login?.userSignup, params);

            return resp;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get User Types
export const UserTypesGet = createAsyncThunk(
    "loginApi/UserTypesGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.login?.getUserTypes);
            if (resp.data && Array.isArray(resp.data.Table)) {

                dispatch(setUserTypes(resp.data.Table)); // Update the state with the user types data
            }
            return Array.isArray(resp.data?.Table) ? resp.data.Table : [];
        } catch (error) {
            console.error('Error fetching user types:', error);
            throw error; // Rethrow error to be handled in component
        }
    }
);

// get Country Codes
export const CountryCodesGet = createAsyncThunk(
    "loginApi/CountryCodesGet",
    async () => {
        try {
            const resp = await axiosApi.get(apiConstants.login?.countryCodesGet);
            return resp.data;
        } catch (error) {
            console.error('Error fetching country codes:', error);
            throw error;
        }
    }
);

const applyLoginSession = (dispatch, data) => {
    const session = normalizeLoginSession(data) || data || {};
    const menuItems =
        session.menu_items ||
        session.menuItems ||
        session.MenuItems ||
        session.Table1 ||
        data?.menu_items ||
        data?.menuItems ||
        data?.MenuItems ||
        [];
    const familyAccounts =
        session.family_accounts ||
        session.familyAccounts ||
        session.Table2 ||
        data?.family_accounts ||
        data?.familyAccounts ||
        [];
    dispatch(setLoginDetails(session));
    dispatch(setMenuItem(Array.isArray(menuItems) ? menuItems : []));
    dispatch(setFamilyAccounts(Array.isArray(familyAccounts) ? familyAccounts : []));
    dispatch(setToken(session.Token || session.token || data?.Token || data?.token));
};

export const passkeyLogin = createAsyncThunk(
    "loginApi/passkeyLogin",
    async (formBody, { dispatch, rejectWithValue }) => {
        try {
            const data = await authenticateWithPasskey(formBody.user_name);
            applyLoginSession(dispatch, data);
            return data;
        } catch (error) {
            return rejectWithValue({
                message: getPasskeyApiError(error),
                code: error?.code || error?.name,
                name: error?.name,
            });
        }
    }
);

//validate User Email
export const validateUserEmail = createAsyncThunk(
    "loginApi/validateUserEmail",
    async (formBody, { dispatch }) => {
        const params = {
            email_address: formBody.email,
        };
        try {
            const resp = await axiosApi.post(apiConstants.login?.validateUserEmail, params);
            dispatch(setValidateUserEmail(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);

//reset Password
export const resetUserPassword = createAsyncThunk(
    "loginApi/resetPassword",
    async (formBody, { dispatch }) => {
        const params = {
            user_id: formBody.user_id,
            password: formBody.password,
        };
        console.log(params, 'params');
        const resp = await axiosApi.post(apiConstants.login?.resetUserPassword, params);
        console.log(resp, 'resp');
        dispatch(setResetUserPassword(resp.data));
        return resp.data;
    }
);
export const validateResetPasswordToken = createAsyncThunk(
    "loginApi/validateResetPasswordToken",
    async (formBody, { dispatch }) => {
        console.log(formBody, 'formBody');
        const resp = await axiosApi.post(apiConstants.login?.validateResetPasswordToken, formBody,
            {
                headers: {
                    Authorization: `Bearer ${formBody}`,
                },
            }
        );
        console.log(resp, 'resp');
        return resp.data;
    }
);
export const validateTokenAccessLink = createAsyncThunk(
    "loginApi/validateTokenAccessLink",
    async (formBody, { dispatch }) => {
        console.log(formBody, 'formBody');
        const resp = await axiosApi.post(apiConstants.login?.validateTokenAccessLink, formBody,
            {
                headers: {
                    Authorization: `Bearer ${formBody}`,
                },
            }
        );
        const data = resp.data;

         dispatch(setLoginDetails(data));
            dispatch(setMenuItem(data.menu_items));
            dispatch(setFamilyAccounts(data.family_accounts));
            dispatch(setToken(data.Token));
        console.log(resp, 'resp');
        return resp.data;
    }
);

//generate One Time Login Link
export const generateOneTimeLoginLink = createAsyncThunk(
    "loginApi/generateOneTimeLoginLink",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.get(apiConstants.login?.generateOneTimeLoginLink + "?UserID=" + formBody.user_id);
        dispatch(setGenerateOneTimeLoginLink(resp.data));
        return resp.data;
    }
);

//reset Password Email Notification
export const resetPasswordEmailNotification = createAsyncThunk(
    "loginApi/ResetPasswordEmailNotification",
    async (formBody, { dispatch }) => {
        const params = {
            user_id: formBody.user_id,
        };
        const resp = await axiosApi.post(apiConstants.login?.resetPasswordEmailNotification, params);
        dispatch(setResetPasswordEmailNotification(resp.data));
        return resp.data;
    }
);

//update Password
export const updatePassword = createAsyncThunk(
    "loginApi/updatePassword",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.post(apiConstants.login?.updatePassword, formBody, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });

        dispatch(setUpdatePassword(resp.data));
        return resp;
    }
);

//Dashboard API
export const getgridHeaders = createAsyncThunk(
    "dashBoardApi/gridHeaders",
    async (formBody, { dispatch }) => {
        try {

            const resp = await axiosApi.get(apiConstants.reports?.getMRGroupsMstrlst + "?SiteID=0&Active=true&UserID=" + formBody.user_id, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },
                params: {
                    SiteID: formBody.SiteID || 0,
                    Active: formBody.Active || true,
                    UserID: formBody.user_id
                }

            });

            return resp.data.Table; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get Medications at Dashboard
export const getMedicationatDashboard = createAsyncThunk(
    "dashBoardApi/MedicationGet",
    async (formBody, { dispatch }) => {

        try {
            const url = `${apiConstants.dashboard.getMedicationatDashboard}?UserID=${formBody.user_id}`;

            const response = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            console.log(response, "response11")

            // Format the response data for the grid
            const formattedData = {
                Table: response.data.Table || []
            };

            // Update Redux store with the formatted data
            dispatch(setGetMediacatiopnsatDashboard(formattedData));

            return formattedData;
        } catch (error) {
            console.error("Error fetching medications:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
            }
            throw error;
        }
    }
);

//get Lab Results at Dashboard
export const getLabResultatDashboard = createAsyncThunk(
    "dashBoardApi/getLabResultatDashboard",
    async (formBody, { dispatch }) => {
        try {
            const url = apiConstants.dashboard.getMRSitesLabResults + "?UserID=" + formBody.user_id
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
                params: {
                    UserID: formBody.user_id
                }
            });

            return resp.data.Table; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get Vitals at Dashboard
export const getVitals = createAsyncThunk(
    "dashBoardApi/getVitals",
    async (formBody, { dispatch }) => {
        try {
            // Construct the URL with query parameters directly
            const url = `${apiConstants.dashboard?.getVitals}?LoginUserID=${formBody.user_id}&latest=false`;

            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },
            });

            return resp.data.Table; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get Widgets at Dashboard
export const WidgetsGet = createAsyncThunk(
    "dashBoardApi/WidgetsGet",
    async (formBody, { dispatch }) => {
        try {
            // console.log(" Token:", formBody.token);
            const url = `${apiConstants.dashboard.getWidgets}?UserID=${formBody.userId}`;
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });

            // If the API returns a Table inside the response
            if (resp.data && Array.isArray(resp.data.Table)) {
                return resp.data.Table;
            } else {
                // console.warn(" Table not found in response or it's not an array. Returning empty array.");
                return [];
            }
        } catch (error) {
            console.error(" WidgetsGet error:", error);
            throw error;
        }
    }
);

//Get Allergies at Dashboard widget
export const UsersAllergiesGet = createAsyncThunk(
    "dashBoardApi/UsersAllergiesGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.dashboard?.getAllergies + "?UserID=" + formBody.UserID, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },

            });

            return resp.data.Table; // Return the response data
        } catch (error) {

            if (error.response) {

            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
            }
            throw error;
        }
    }
);

//Get Medical History at Dashboard widget
export const UsersMedicalHistoryGet = createAsyncThunk(
    "dashBoardApi/UsersMedicalHistoryGet",
    async (formBody, { dispatch }) => {
        try {
            const url = apiConstants.dashboard?.getUserMedicalHistory +
                "?UserID=" + formBody.UserID +
                "&medical_history=" + formBody.medical_history +
                "&surgical_history=" + formBody.surgical_history +
                "&dental_history=" + formBody.dental_history;

            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data.Table;
        } catch (error) {
            throw error;
        }
    }
);

// Get with you at shared reports
export const IinternalSharedReportsFromOthers = createAsyncThunk(
    "dashBoardApi/IinternalSharedReportsFromOthers",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.reports?.IinternalSharedReportsFromOthers}?LoginUserID=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );
            dispatch(setSharedReportsFromOthers(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);
export const InternalSharedReportSaveforShareReport = createAsyncThunk(
    "dashBoardApi/InternalSharedReportSaveforShareReport",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.reports.InternalSharedReportSave, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                }
            });
            return resp;
        } catch (error) {
            console.error("Error in InternalSharedReportSaveforShareReport:", error);
            throw error;
        }
    }
);
export const sendDocumenttoEmail = createAsyncThunk(
    "dashBoardApi/sendDocumentEmail",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.reports.sendDocumentEmail, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                }
            });
            return resp;
        } catch (error) {
            console.error("Error in sendDocumentEmail:", error);
            throw error;
        }
    }
);
export const getQRCode = createAsyncThunk(
    "dashBoardApi/getQRCode",
    async (formBody, { dispatch }) => {
        try {
            console.log("formBody", formBody);
            const url = apiConstants.reports.getReportLink + "?UserID=" + formBody.UserID + "&ReportID=" + formBody.ReportID;
            console.log("url", url);
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                }
            });
            return resp.data;
        } catch (error) {
            console.error("Error in getQRCode:", error);
            throw error;
        }
    }
);
export const getValidityOptions = createAsyncThunk(
    "dashBoardApi/getValidityOptions",
    async (formBody, { dispatch }) => {
        try {
            console.log("formBody", formBody);

            const URL = apiConstants.reports.getValidityOptions + "LoginUserID=" + formBody.user_id;
            console.log("URL", URL);
            const resp = await axiosApi.get(URL, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                }
            });
            return resp.data;
        } catch (error) {
            console.error("Error in getValidityOptions:", error);
            throw error;
        }
    }
);
// Get By you at shared reports
export const InternalSharedReportsToOthers = createAsyncThunk(
    "dashBoardApi/InternalSharedReportsToOthers",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.reports?.InternalSharedReportsToOthers}?LoginUserID=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },

                }
            );
            dispatch(setSharedReportsToOthers(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

// Get Approve Access at shared reports
export const InternalSharedReportsFromOthersComplete = createAsyncThunk(
    "dashBoardApi/InternalSharedReportsFromOthersComplete",
    async (formBody, { dispatch }) => {
        try {
            const url = `${apiConstants.reports?.InternalSharedReportsFromOthersComplete}?LoginUserID=${formBody.user_id}`;

            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });

            // Check if we have the expected data structure
            if (!resp.data) {
                console.error("No data in response");
                throw new Error("No data received from API");
            }
            // Dispatch the action with the data
            dispatch(setSharedReportsFromOthersComplete(resp.data.Table1));

            // Return the full response data
            return resp.data;
        } catch (error) {
            console.error("Error in InternalSharedReportsFromOthersComplete:", error);
            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
                console.error("Response headers:", error.response.headers);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Request setup error:", error.message);
            }
            throw error;
        }
    }
);

// Get share EveryWhere Categories at shared reports
export const ReportCategoriesGet = createAsyncThunk(
    "dashBoardApi/ReportCategoriesGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.reports?.ReportCategoriesGet}?LoginUserID=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            dispatch(setSharedReportsReportCategoriesGet(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

// Get ValidityGet at shared reports
export const SharedReportValidityGet = createAsyncThunk(
    "dashBoardApi/SharedReportValidityGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.reports?.SharedReportValidityGet}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            dispatch(setSharedReportValidityGet(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

// Get Generate code at shared reports
export const sharedReportGeneratecodeGet = createAsyncThunk(
    "dashBoardApi/SharedReportGeneratecodeGet",
    async (formBody, { dispatch }) => {
        // Sending all required params
        const params = {
            UserID: formBody.user_id,
            CategoryID: formBody.CategoryID,
            DurationID: formBody.DurationID,
            ShareWithName: formBody.ShareWithName
        };
        try {
            const resp = await axiosApi.post(
                apiConstants.reports.sharedReportGeneratecodeGet,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            dispatch(setSharedReportGeneratecodeGet(resp.data));
            const data = resp.data;
            return data;
        } catch (error) {
            // Enhanced error logging
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

// Get QR code at shared reports
export const shareReportQRCodeURL = createAsyncThunk(
    "dashBoardApi/shareReportQRCodeURL",
    async (formBody, { dispatch, rejectWithValue }) => {
        try {
            const { user_id, token, shareId } = formBody;
            console.log(user_id, "user_id for shareReportQRCodeURL")
            console.log(token, "token for shareReportQRCodeURL")
            console.log(shareId, "shareId for shareReportQRCodeURL")
            const url = `${apiConstants.reports.shareReportQRCodeURL}?EveryWhereShareID=${shareId}&UserID=${user_id}`;

            const response = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            dispatch(setShareReportQRCodeURL(response.data));
            return response.data;
        } catch (error) {
            // Enhanced error handling
            if (error.response) {
                console.error("API Response Error:", error.response.data);
                return rejectWithValue(error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

// Get ValidCodes at shared reports
export const sharedReportsValidCodesGet = createAsyncThunk(
    "dashBoardApi/SharedReportsValidCodesGet",
    async (formBody, { rejectWithValue }) => {
        try {
            const { user_id, token } = formBody;
            const url = `${apiConstants.reports.sharedReportsValidCodesGet}?UserID=${user_id}`;

            const response = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            return response.data;
        } catch (error) {
            // Enhanced error handling
            if (error.response) {
                console.error("API Response Error:", error.response.data);
                return rejectWithValue(error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

export const internalSharedReportRevoke = createAsyncThunk(
    "dialogApiService/internalSharedReportRevoke",
    async (formBody, { dispatch }) => {
        console.log(formBody, "formBody for internalSharedReportRevoke");
        const params = {
            LoginUserID: formBody.user_id,
            ShareID: formBody.share_id,
        };
        try {
            const resp = await axiosApi.post(
                apiConstants.reports.internalSharedReportRevoke,
                params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            console.log(resp.data, "resp.data123");
            dispatch(setInternalSharedReportRevoke(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);

//get Provider Notes at shared reports
export const getProviderNotes = createAsyncThunk(
    "dashBoardApi/getProviderNotes",
    async (formBody, { dispatch }) => {
        const params = {
            UserID: formBody.user_id,
        };
        try {
            const resp = await axiosApi.post(apiConstants.reports.getProviderNotes, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            dispatch(setProviderNotesData(resp.data));
            return resp.data;
        } catch (error) {
            console.log(error, "error for getProviderNotes");
        }
    }


);

// Get MRSitesReports at shared reports
export const getMRSitesReports = createAsyncThunk(
    "dashBoardApi/MRSitesReportsGet",
    async (formBody, { dispatch }) => {
        try {
            // Use all parameters for filtering/searching
            const params = {
                UserID: formBody.user_id,
                SearchKey: formBody.SearchKey,
                ReportGroupName: formBody.ReportGroupName,
                ProviderName: formBody.ProviderName,
                HospitalName: formBody.HospitalName,
                ReportDateStart: formBody.ReportDateStart,
                ReportDateEnd: formBody.ReportDateEnd,
                SiteID: formBody.SiteID || 0,
                IncludeArchived: formBody.IncludeArchived || false,
                ReportID: formBody.ReportID || 0
            };
            const resp = await axiosApi.post(apiConstants.reports.getMRSitesReports, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            const data = resp.data;
            dispatch(setReportsData(resp.data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get MR Sites Reports by Report ID
export const mrSitesReportsGetByReportID = createAsyncThunk(
    "dashBoardApi/MRSitesReportsGetByReportID",
    async (formBody, { rejectWithValue }) => {
        try {
            const { UserID, ReportID } = formBody;
            const url = `${apiConstants.reports.mrSitesReportsGetByReportID}?ReportID=${ReportID}&UserID=${UserID}`;

            const response = await axiosApi.get(url, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${formBody.token}`,

                },
                responseType: 'blob',
            });
            console.log(response.data, "response.data for mrSitesReportsGetByReportID")
            const contentType =
                response.headers?.['content-type'] ||
                response.headers?.['Content-Type'];
            let blob = response.data;
            if (blob instanceof Blob && contentType) {
                const mime = contentType.split(';')[0].trim();
                if (mime && (!blob.type || blob.type === 'application/octet-stream')) {
                    blob = new Blob([blob], { type: mime });
                }
            }
            return blob;
        } catch (error) {
            // Enhanced error handling
            if (error.response) {
                console.error("API Response Error:", error.response.data);
                return rejectWithValue(error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

//get All MRSitesReports
export const getAllMRSItesReports = createAsyncThunk(
    "dashBoardApi/MRSitesReportsGet",
    async (formBody, { dispatch }) => {
        const params = {
            ReportGroupName: formBody.ReportGroupName,
            ProviderName: formBody.ProviderName,
            HospitalName: formBody.HospitalName,
            UserID: parseInt(formBody.UserID),
            SearchKey: formBody.SearchKey,
            ReportDateStart: formBody.ReportDateStart,
            ReportDateEnd: formBody.ReportDateEnd,
            SiteID: 0
        };
        try {
            const resp = await axiosApi.post(apiConstants.reports.getMRSitesReports, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            const data = resp.data;
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

// Get MRSitesReportsGet
export const getMRSitesReportsGet = createAsyncThunk(
    "dashBoardApi/MRSitesReportsGet",
    async (formData, { dispatch }) => {
        const Token = formData.token;
        const params = {
            ProviderName: "",
            HospitalName: "",
            UserID: formData.UserID,
            SearchKey: "",
            ReportDateStart: null,
            ReportDateEnd: null,
            SiteID: 0
        };

        try {
            const response = await axiosApi.post(
                apiConstants.reports?.getMRSitesReportsGet,
                params,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        "Authorization": `Bearer ${Token}`,
                    },
                    withCredentials: true,
                }
            );
            const reports = response.data?.Table || []; // Ensure correct data extraction
            return reports;
        } catch (error) {
            throw error;
        }
    }
);

//Get Vaccination at Dashboard widget
export const VaccinationsGet = createAsyncThunk(
    "dashBoardApi/VaccinationsGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.dashboard?.getVaccianations + "?UserID=" + formBody.UserID, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },
            });
            return resp.data.Table; // Return the response data
        } catch (error) {
            throw error;
        }
    }
);

//Get Provider Notes at Dashboard widget
export const MRSitesProvidersNotesReportsGet = createAsyncThunk(
    "dashBoardApi/MRSitesProvidersNotesReportsGet",
    async (formBody, { dispatch }) => {
        try {

            const resp = await axiosApi.get(apiConstants.dashboard?.getProviderNotes + "?UserID=" + formBody.UserID, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },

            });

            return resp.data.Table; // Return the response data
        } catch (error) {
            throw error;
        }
    }
);

//Get Users Appointments at Dashboard widget
export const UsersAppointmentsGet = createAsyncThunk(
    "dashBoardApi/UsersAppointmentsGet",
    async (formBody, { dispatch }) => {
        try {

            const resp = await axiosApi.get(apiConstants.dashboard?.getUserAppointmentDetails + "?UserID=" + formBody.UserID, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },
            });
            return resp.data.Table; // Return the response data
        } catch (error) {
            console.log("vaccination data:", error.response.data)
            throw error;
        }
    }
);

//get Users Widgets Add
export const UsersWidgetsAdd = createAsyncThunk(
    "dashBoardApi/UsersWidgetsAdd",
    async (formBody, { dispatch }) => {
        try {
            // Define the payload with the required inputs
            const payload = {
                UserId: formBody.UserId,
                WidgetId: formBody.WidgetId,
                LoggedInUserId: formBody.LoggedInUserId,
            };

            // Make the API call
            const resp = await axiosApi.post(apiConstants.dashboard?.AddUserWidgets, payload, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },
            });

            // Log the API response


            return resp.data; // Return the response data
        } catch (error) {
            console.error("UsersWidgetsAdd API Error:", error.message);

            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
                console.error("Response headers:", error.response.headers);
            } else if (error.request) {
                console.error("No response received from server:", error.request);
            } else {
                console.error("Error setting up the request:", error.message);
            }

            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get Users Widgets Delete
export const UsersWidgetsDelete = createAsyncThunk(
    "dashBoardApi/UsersWidgetsDelete",
    async (formBody, { dispatch }) => {
        try {
            // Define the payload with the required inputs
            const payload = {
                UserId: formBody.UserId,
                WidgetId: formBody.WidgetId,
                LoggedInUserId: formBody.LoggedInUserId,
            };

            // Make the API call
            const resp = await axiosApi.post(apiConstants.dashboard?.DeleteUserWidgets, payload, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Authorization header
                },
            });


            return resp.data; // Return the response data
        } catch (error) {
            console.error("DeleteUserWidgets API Error:", error.message);

            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
                console.error("Response headers:", error.response.headers);
            } else if (error.request) {
                console.error("No response received from server:", error.request);
            } else {
                console.error("Error setting up the request:", error.message);
            }

            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get LogUserMenuAnalytics
export const getLogUserMenuAnalytics = createAsyncThunk(
    "dashBoardApi/LogUserMenuAnalytics",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.post(apiConstants.dashboard?.getLogUserMenuAnalytics, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            // Only return the data part of the response, not the entire response object
            const responseData = resp.data;
            console.log("LogUserMenuAnalytics response:", responseData);
            return responseData;
        } catch (error) {
            console.error("LogUserMenuAnalytics error:", error);
            throw error;
        }
    }
);

//Get Application Announcements
// export const getApplicationAnnouncements = createAsyncThunk(
//     "dashBoardApi/ApplicationAnnouncementsGet",
//     async (formBody, { dispatch }) => {
//         try {
//             const url = `${apiConstants.dashboard?.getApplicationAnnouncements}?LoginUserID=${formBody.LoginUserID}`;
//             const resp = await axiosApi.get(url, {
//                 headers: {
//                     Authorization: `Bearer ${formBody.token}`,
//                 },
//             });
//             console.log("ApplicationAnnouncementsGet response:", resp.data.Table);
//             return resp.data.Table || []; // Return the response data
//         } catch (error) {
//             console.error("ApplicationAnnouncementsGet error:", error);
//             if (error.response) {
//                 console.error("Response data:", error.response.data);
//                 console.error("Response status:", error.response.status);
//             } else if (error.request) {
//                 console.error("No response received:", error.request);
//             } else {
//                 console.error("Error in setup:", error.message);
//             }
//             throw error;
//         }
//     }
// );

// Get Announcements
export const announcementsGet = createAsyncThunk(
    "blogApi/AnnouncementsGet",
    async (formBody, { dispatch }) => {

        // Sending all required params
        const params = {
            announcement_id: formBody.announcement_id,
            hospital_id: formBody.hospital_id,
            role_id: formBody.role_id,
            loggedin_userID: formBody.user_id
        };

        try {
            const resp = await axiosApi.post(apiConstants.blog.announcementsGet, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            const data = resp.data;
            dispatch(setAnnouncementsGet(data));
            return data;
        } catch (error) {
            // Enhanced error logging
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

// Loading data for Advance Search at report page

//Get Providers

//Save Announcements
export const announcementsSave = createAsyncThunk(
    "blogApi/AnnouncementsSave",
    async (formBody, { dispatch }) => {

        const formData = new FormData();

        // Safely append all form values
        formData.append("title", formBody.title || "");
        formData.append("sub_title", formBody.sub_title || "");
        formData.append("description", formBody.description || "");
        formData.append("card_link", formBody.card_link || "");
        formData.append("role_ids", formBody.role_ids || "");
        formData.append("valid_up_to", formBody.valid_up_to ?? "");
        formData.append("is_active", formBody.is_active);
        formData.append("is_web_url", formBody.is_web_url);
        formData.append("created_by", formBody.user_id);


        // Handle image properly
        if (formBody.imageFile) {
            // If there's an actual file, append the file
            formData.append("image_file", formBody.imageFile);
            console.log("Uploading image file:", formBody.imageFile.name);
        } else if (formBody.is_web_url && formBody.image_url) {
            // If it's a web URL and not a blob URL, use it
            if (!formBody.image_url.startsWith('blob:') && !formBody.image_url.includes('/AnnouncementImages/blob:')) {
                formData.append("image_url", formBody.image_url);
                console.log("Using web URL:", formBody.image_url);
            } else {
                console.warn("Blob URL detected in web URL field, ignoring:", formBody.image_url);
                formData.append("image_url", "");
            }
        } else {
            // No image
            formData.append("image_url", "");
        }

        try {
            const resp = await axiosApi.post(apiConstants.blog.announcementsSave, formData, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    // No need to set Content-Type manually for FormData
                },
            });

            const data = resp.data;
            dispatch(setAnnouncementsSave(data));

            return data;
        } catch (error) {
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

//Update Announcements
export const announcementsUpdate = createAsyncThunk(
    "blogApi/AnnouncementsUpdate",
    async (formBody, { dispatch }) => {
        const formData = new FormData();

        // Safely append all form values with correct field names
        formData.append("announcement_id", formBody.announcement_id || 0);
        formData.append("title", formBody.title || "");
        formData.append("sub_title", formBody.sub_title || "");
        formData.append("description", formBody.description || "");
        formData.append("card_link", formBody.card_link || "");
        formData.append("role_ids", formBody.role_ids || "");
        formData.append("valid_up_to", formBody.valid_up_to ?? "");
        formData.append("is_active", formBody.is_active);
        formData.append("is_web_url", formBody.is_web_url);
        formData.append("updated_by", formBody.updated_by);

        // Handle image properly
        if (formBody.imageFile) {
            // If there's an actual file, append the file
            formData.append("image_file", formBody.imageFile);
            console.log("Updating with image file:", formBody.imageFile.name);
        } else if (formBody.is_web_url && formBody.image_url) {
            // If it's a web URL and not a blob URL, use it
            if (!formBody.image_url.startsWith('blob:') && !formBody.image_url.includes('/AnnouncementImages/blob:')) {
                formData.append("image_url", formBody.image_url);
                console.log("Using web URL:", formBody.image_url);
            } else {
                console.warn("Blob URL detected in web URL field, ignoring:", formBody.image_url);
                formData.append("image_url", "");
            }
        } else {
            // Keep existing image or no image
            formData.append("image_url", formBody.image_url || "");
        }

        try {
            const resp = await axiosApi.post(apiConstants.blog.announcementsUpdate, formData, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    // No need to set Content-Type manually for FormData
                },
            });

            const data = resp.data;
            dispatch(setAnnouncementsUpdate(data));
            return data;
        } catch (error) {
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);


//Get Providers for Advance Search
export const getProviderforAdvanceSearch = createAsyncThunk(
    "user/getProviderforAdvanceSearch",
    async (formBody, { dispatch }) => {
        const params = {
            UserID: formBody.user_id,
            ProviderId: 0
        };

        try {
            const resp = await axiosApi.post(apiConstants.users.ProvidersGet, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            const data = resp.data;
            console.log("data for getProviderforAdvanceSearch", resp);


            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//Get Hospitals
export const getHospitalsforAdvanceSearch = createAsyncThunk(
    "user/getHospitalsforAdvanceSearch",
    async (formBody, { dispatch }) => {
        const params = {
            UserID: formBody.user_id,
            HospitalID: 0
        };

        try {
            const resp = await axiosApi.post(apiConstants.users.HospitalsGet, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });
            const data = resp.data;

            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get Receipts
export const getReceipts = createAsyncThunk(
    "user/getReceipts",
    async (formBody, { dispatch }) => {
        const params = {
            UserID: formBody.UserID,
            IncludeArchived: formBody.IncludeArchived,
            SearchKey: formBody.SearchKey,
            ReceiptDate: formBody.ReceiptDate,
            HospitalName: formBody.HospitalName
        };

        try {
            const resp = await axiosApi.post(apiConstants.spends.getReceipts, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                },
            });

            const data = resp.data;

            return data;
        } catch (error) {
            throw error;
        }
    }
);

//get Receipts By ID
export const getReceiptsByID = createAsyncThunk(
    "user/getReceiptsByID",
    async (formBody, { dispatch }) => {
        try {
            const url = `${apiConstants.reports.mrSitesReportsGetByReportID}?ReportID=${formBody.ReceiptID}&UserID=${formBody.UserID}`;
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/pdf',
                },
                responseType: 'blob',
            });

            const data = resp.data
            return data;
        } catch (error) {
            throw error;
        }
    }
);

//delete Reports
export const deleteReports = createAsyncThunk(
    "dashBoardApi/deleteReports",
    async (formBody, { dispatch }) => {
        const url = apiConstants.reports.deleteReports + "UserID=" + formBody.UserID + "&ReportID=" + formBody.ReportID + "&LoginUserID=" + formBody.LoginUserID;

        const resp = await axiosApi.get(url, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });

        return resp.data;

    }
);

//archive Report
export const archiveReport = createAsyncThunk(
    "dashBoardApi/archiveReport",
    async (formBody, { dispatch }) => {
        const url = apiConstants.reports.archivereports + "Archivedby=" + formBody.UserID + "&ReportID=" + formBody.ReportID + "&LoginUserID=" + formBody.LoginUserID;

        const resp = await axiosApi.get(url, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;

    }
);

//to archvie receipts at spends
export const archiveReceipts = createAsyncThunk(
    "dashBoardApi/archiveReceipts",
    async (formBody, { dispatch }) => {
        const url = apiConstants.spends.archiveReceipts + "receiptID=" + formBody.receiptId + "&UserID=" + formBody.UserID;
        const resp = await axiosApi.get(url, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;
    }
);

//to undo (restore) archived receipts at spends
export const undoArchiveReceipts = createAsyncThunk(
    "dashBoardApi/undoArchiveReceipts",
    async (formBody, { dispatch }) => {
        try {
            const url = `${apiConstants.spends.undoArchiveReceipts}?receipt_id=${formBody.receipt_id}&user_id=${formBody.user_id}`;
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
            });
            return resp.data;
        } catch (error) {
            console.log("undoArchiveReceipts error", error);
            throw error;
        }
    }
);

//To delete receipts at spends
export const deleteReceipts = createAsyncThunk(
    "dashBoardApi/deleteReceipts",
    async (formBody, { dispatch }) => {
        const url = apiConstants.spends.deleteReceipts;
        const resp = await axiosApi.post(url, formBody, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
    }
);

//TO get notes at notes
export const getNotes = createAsyncThunk(
    "dashBoardApi/getNotes",
    async (formBody, { dispatch }) => {
        const url = apiConstants.notes.getNotes + "UserID=" + formBody.UserID;
        const resp = await axiosApi.get(url, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;

    }
);
export const getNotesforReports = createAsyncThunk(
    "dashBoardApi/getNotesforReports",
    async (formBody, { dispatch }) => {
        const url = apiConstants.reports.getNotesatReports + "loginUserId="+ formBody.UserID+"&reportId="+formBody.ReportID;
        const resp = await axiosApi.get(url, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;

    }
);

export const saveNotesforReports = createAsyncThunk(
    "dashBoardApi/saveNotesforReports",
    async (formBody, { dispatch }) => {
        const url = apiConstants.reports.saveNoteforReport;
        const resp = await axiosApi.post(url, formBody, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,  
            },
        });
        return resp.data;
    }
);


//to save writtem notes at MY notes
export const createNote = createAsyncThunk(
    "dashBoardApi/createNote",
    async (formBody, { dispatch }) => {
        console.log("formBody for createNote", formBody);
        const params = {
            userID: formBody.userID,
            notes: "<p>" + formBody.notes + "<p/>",
            title: formBody.title,
            notesID: null,
        }
        const url = apiConstants.notes.createNote;
        const resp = await axiosApi.post(url, params, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;
    }
);

//to update notes at MY notes
export const updateNote = createAsyncThunk(
    "dashBoardApi/updateNote",
    async (formBody, { dispatch }) => {
        console.log("formBody for updateNote", formBody);
        const url = apiConstants.notes.updateNote;
        const resp = await axiosApi.post(url, formBody, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;
    }
);

//to delete notes at MY notes

export const deleteNote = createAsyncThunk(
    "dashBoardApi/deleteNote",
    async (formBody, { dispatch }) => {
        const url = apiConstants.notes.deleteNote;
        const resp = await axiosApi.post(url, formBody, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data;
    }
);

//save Report Document
export const saveReportDocument = createAsyncThunk(
    "document/saveReportDocument",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosApi.post(
                apiConstants.reports.saveReportsDocument,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${formData.get('token')}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response.data;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);
export const saveReceipts = createAsyncThunk(
    "document/saveReportDocument",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosApi.post(
                apiConstants.spends.saveReceipts,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${formData.get('token')}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);

//get MR Groups Mstrlst
export const getMRGroupsMstrlst = createAsyncThunk(
    "MRSites/MRGroupsMstrGet",
    async (formBody, { dispatch }) => {
        try {
            // Construct the URL with query parameters
            const url = `${apiConstants.reports.getMRGroupsMstrlst}`;

            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
                params: {
                    SiteID: formBody.SiteID || 0,
                    Active: formBody.Active || true,
                    UserID: formBody.user_id || 5
                }
            });

            const data = resp.data;
            return data;
        } catch (error) {
            console.error('Error in getMRGroupsMstrlst:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
            }
            throw error;
        }
    }
);

//save MR Groups Mstr Insert
export const saveMRGroupsMstrInsert = createAsyncThunk(
    "MRSites/MRGroupsMstrInsert",
    async (formBody, { dispatch }) => {
        const params = {
            Name: formBody.GroupName,
            Login_User_ID: formBody.UserID
        };

        try {
            const resp = await axiosApi.post(apiConstants.reports.saveMRGroupsMstrInsert, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            const data = resp.data;

            return data;
        } catch (error) {
            throw error;
        }
    }
);

// get vitals history
export const getVitalsHistory = createAsyncThunk(
    "dashBoardApi/VitalsGetHistory",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.dashboard.getVitalsHistory, {
                params: {
                    LoginUserID: formBody.LoginUserID, // or formBody.UserID if that's what you use
                    latest: formBody.latest
                },
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data.Table; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

export const getMetabolicsHistory = createAsyncThunk(
    "dashBoardApi/MetabolicsGetHistory",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.dashboard.getMetabolicsHistory, {
                params: {
                    LoginUserID: formBody.LoginUserID,
                    latest: formBody.latest
                },
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data.Table;
        } catch (error) {
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                console.log("Request:", error.request);
            } else {
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get User Risk Analysis Data
export const getUserRiskAnalysisData = createAsyncThunk(
    "dashBoardApi/GetUserRiskAnalysisData",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.riskCalculator?.getUserRiskAnalysisData}?UserId=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );

            dispatch(setGetUserRiskAnalysisData(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//extract Risk Calculator Data
export const extractRiskCalculatorData = createAsyncThunk(
    "riskApi/extractRiskCalculatorData",
    async (formBody, { dispatch }) => {

        const params = {
            userId: formBody.userId,
            age: formBody.age,
            height: formBody.height,
            weight: formBody.weight,
            systolicBp: formBody.systolicBp,
            diastolicBp: formBody.diastolicBp,
            totalCholesterol: formBody.totalCholesterol,
            hdl: formBody.hdl,
            ldl: formBody.ldl,
            sex: formBody.sex,
            on_diabetes_medication: formBody.on_diabetes_medication,
            on_hypertension_medication: formBody.on_hypertension_medication,
            smoker: formBody.smoker,
            on_aspirin: formBody.on_aspirin,
            on_statin: formBody.on_statin,
            race: formBody.race
        };

        try {
            const response = await axiosApi.post(apiConstants.riskCalculator.extractRiskCalculatorData, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                        "Content-Type": "application/json"
                    },
                }
            );

            const data = response.data;

            // Optionally dispatch to your Redux store
            dispatch(setExtractRiskCalculatorData(data));

            return data;
        } catch (error) {
            if (error.response) {
                console.error("API Response Error:", error.response.data);
            } else if (error.request) {
                console.error("No response received:", error.request);
            } else {
                console.error("Error in setup:", error.message);
            }
            throw error;
        }
    }
);

//get Users Details
//Profile API's
export const profileUsersDetailsGet = createAsyncThunk(
    "profileApi/UsersDetailsGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.profile?.profileUsersDetailsGet}?UserId=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );

            dispatch(setUsersDetailsGet(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get Family Relations
export const familyRelationsGet = createAsyncThunk(
    "profileApi/FamilyRelationsGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.profile?.familyRelationsGet}?LoginUserID=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );

            dispatch(setFamilyRelationsGet(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get Family Members Users
export const familyMembersUsersGet = createAsyncThunk(
    "profileApi/FamilyMembersUsersGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.profile?.familyMembersUsersGet,
                {
                    LoginUserID: formBody.user_id,
                    SearchKey: formBody.SearchKey || "",
                },
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );

            dispatch(setFamilyMembersUsersGet(resp.data));
            return resp.data;
        } catch (error) {
            // Handle error here
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                console.log("Request:", error.request);
            } else {
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get Family Accounts
export const familyAccountsGetNew = createAsyncThunk(
    "profileApi/FamilyAccountsGetNew",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(
                `${apiConstants.profile?.familyAccountsGetNew}?UserID=${formBody.user_id}&&LoggedinUserID=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );

            dispatch(setFamilyAccountsGetNew(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//userPhotoUpload
export const userPhotoUpload = createAsyncThunk(
    "profileApi/userPhotoUpload",
    async (formBody, { dispatch }) => {

        const formData = new FormData();
        formData.append("Imagepath", formBody.Imagepath);
        formData.append("UserID", formBody.UserID);
        formData.append("section", "general");
        formData.append("token", formBody.token);

        try {
            const resp = await axiosApi.post(apiConstants.profile?.userPhotoUpload, formData, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
                body: formData
            });

            dispatch(setUserPhotoUpload(resp.data));
            return resp.data;
        } catch (error) {
            throw error;
        }
    }
);

//update User Details
export const userDetailsUpdate = createAsyncThunk(
    "profileApi/UserDetailsUpdate",
    async (formBody, { dispatch }) => {
        const params = {
            first_name: formBody.first_name,
            last_name: formBody.last_name,
            gender: formBody.gender,
            phone: formBody.phone,
            date_of_birth: formBody.date_of_birth,
            user_id: formBody.user_id,
            section: formBody.section,
            address1: formBody.address1,
            address2: formBody.address2,
            city: formBody.city,
            state: formBody.state,
            zip: formBody.zip,
            country: formBody.country,
            alternate_email: formBody.alternate_email,


        };

        try {
            const resp = await axiosApi.post(apiConstants.profile?.userDetailsUpdate, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }

            );
            const data = resp.data;

            dispatch(setUserDetailsUpdate(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//delete Family Account
export const familyAccountDelete = createAsyncThunk(
    "profileApi/FamilyAccountDelete",
    async (formBody, { dispatch, getState }) => {
        const params = {
            FamilyAccountID: formBody.FamilyAccountID,
            UserID: formBody.user_id,
        };

        // Get token from Redux state as backup
        const state = getState();
        const stateToken = state.apiService.token;
        // console.log("familyAccountDelete - token from state:", stateToken);

        // Use token from formBody or fallback to state token
        const tokenToUse = formBody.token || stateToken;

        if (!tokenToUse) {
            // console.error("familyAccountDelete - No token available!");
            throw new Error("No authentication token available");
        }

        // console.log("familyAccountDelete - using token:", tokenToUse);

        try {
            const resp = await axiosApi.post(apiConstants.profile?.familyAccountDelete, params,
                {
                    headers: {
                        Authorization: `Bearer ${tokenToUse}`,
                        'Content-Type': 'application/json'
                    },
                }
            );
            const data = resp.data;
            // console.log("familyAccountDelete - success:", data);
            dispatch(setFamilyAccountDelete(data));
            return data;
        } catch (error) {
            // Enhanced error logging
            console.error("familyAccountDelete - Error occurred:", error);
            if (error.response) {
                console.error("familyAccountDelete - Response data:", error.response.data);
                console.error("familyAccountDelete - Response status:", error.response.status);
                console.error("familyAccountDelete - Response headers:", error.response.headers);

                // Check if it's specifically a token issue
                if (error.response.status === 401) {
                    console.error("familyAccountDelete - JWT Token is invalid or expired");
                    console.error("familyAccountDelete - Current token:", tokenToUse);
                }
            } else if (error.request) {
                console.error("familyAccountDelete - Request:", error.request);
            } else {
                console.error("familyAccountDelete - Error:", error.message);
            }
            throw error;
        }
    }
);

//create Family Account
export const familyAccountCreate = createAsyncThunk(
    "profileApi/FamilyAccountCreate",
    async (formBody, { dispatch }) => {
        const params = {
            RelationTypeID: formBody.RelationTypeID,
            UserID: formBody.user_id,
            RelativeUserID: formBody.RelativeUserID,
        };

        try {
            const resp = await axiosApi.post(apiConstants.profile?.familyAccountCreate, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }

            );
            const data = resp;

            dispatch(setFamilyAccountCreate(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//Notification API's
// export const notificationsGet = createAsyncThunk(
//     "profileApi/NotificationsGet",
//     async (formBody, { dispatch }) => {
//         console.log("notificationsGet", formBody);
//         try {
//             const resp = await axiosApi.get(
//                 `${apiConstants.notifications?.notificationsGet}?UserId=${formBody.user_id}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
//                     },
//                 }
//             );

//             console.log("notificationsGet", resp);
//             dispatch(setNotificationsGet(resp.data));
//             return resp.data; // Return the response data
//         } catch (error) {
//             // Handle error here if needed
//             if (error.response) {
//                 console.log("Response data:", error.response.data);
//                 console.log("Response status:", error.response.status);
//                 console.log("Response headers:", error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 console.log("Request:", error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an error
//                 console.log("Error:", error.message);
//             }
//             throw error; // Re-throw the error to be handled by the async thunk
//         }
//     }
// );

//notificationsShown
// export const notificationsShown = createAsyncThunk(
//     "profileApi/NotificationsShown",
//     async (formBody, { dispatch }) => {
//         const params = {
//             UserID: formBody.user_id,
//             NotificationID: formBody.notificationId,
//         };
//         console.log("notificationsShown params", params)
//         try {
//             const resp = await axiosApi.post(apiConstants.notifications?.notificationsShown, params,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${formBody.token}`,
//                     },
//                 }

//             );
//             const data = resp.data;
//             console.log("notificationsShown", resp);
//             dispatch(setNotificationsShown(data));
//             return data;
//         } catch (error) {
//             // Handle error here if needed
//             if (error.response) {
//                 console.log("Response data:", error.response.data);
//                 console.log("Response status:", error.response.status);
//                 console.log("Response headers:", error.response.headers);
//             } else if (error.request) {
//                 // The request was made but no response was received
//                 console.log("Request:", error.request);
//             } else {
//                 // Something happened in setting up the request that triggered an error
//                 console.log("Error:", error.message);
//             }
//             throw error;
//         }
//     }
// );

//get User Details
//Admin

export const getUserDetailsGet = createAsyncThunk(
    "adminApi/UsersDetailsGet",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.get(
                `${apiConstants.admin?.getUserDetailsGet}?UserId=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );


            dispatch(setGetUserDetailsGet(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // 401 Unauthorized: axios rejects; redirect to login like header logout (MemoryRouter-safe).
            if (error.response?.status === 401) {
                dispatch({ type: "LOGOUT" });
                window.location.replace("/");
            }
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get User Management Details
export const getUserManagementDetailsGet = createAsyncThunk(
    "profileApi/UserManagementDetailsGet",
    async (formBody, { dispatch }) => {
        const params = {
            UserID: formBody.user_id,
            SearchKey: "",
            IsGlobalSearch: "false",
        };

        try {
            const resp = await axiosApi.post(apiConstants.admin?.getUserManagementDetailsGet, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }

            );
            const data = resp.data;

            dispatch(setGetUserManagementDetailsGet(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get Users Management Reports
export const getUsersManagementReportsGet = createAsyncThunk(
    "profileApi/UsersManagementReportsGet",
    async (formBody, { dispatch }) => {
        const params = {
            ReportGroupName: "",
            SearchKey: "",
            ReportDateStart: "null",
            ReportDateEnd: "null",
            SiteID: 0,
        };

        try {
            const resp = await axiosApi.post(apiConstants.admin?.getUsersManagementReportsGet, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }

            );
            const data = resp.data;

            dispatch(setGetUsersManagementReportsGet(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//get Genders List
export const getGendersList = createAsyncThunk(
    "adminApi/GendersList",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.get(
                `${apiConstants.admin?.getGendersList}?UserId=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );
            dispatch(setGetGendersList(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get Roles List
export const getRolesList = createAsyncThunk(
    "adminApi/RolesList",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.get(
                `${apiConstants.admin?.getRolesList}?UserId=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );
            dispatch(setGetRolesList(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//get Subscriptions List
export const getSubscriptionsList = createAsyncThunk(
    "adminApi/SubscriptionsList",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.get(
                `${apiConstants.admin?.getSubscriptionsList}?UserId=${formBody.user_id}`,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`, // Correct Authorization header
                    },
                }
            );
            dispatch(setGetSubscriptionsList(resp.data));
            return resp.data; // Return the response data
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error; // Re-throw the error to be handled by the async thunk
        }
    }
);

//update User Management Details
export const usersManagementDetailsUpdate = createAsyncThunk(
    "adminApi/UsersManagementDetailsUpdate",
    async (formBody, { dispatch }) => {
        const params = {
            FirstName: formBody.FirstName,
            LastName: formBody.LastName,
            GenderID: formBody.GenderID,
            RoleID: formBody.RoleID,
            SubscriptionID: formBody.SubscriptionID,
            Phone: formBody.Phone,
            Active: formBody.Active,
            LoginUserID: formBody.LoginUserID,
            UserID: formBody.user_id,
        };

        try {
            const resp = await axiosApi.post(apiConstants.admin?.usersManagementDetailsUpdate, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            const data = resp.data;

            dispatch(setUsersManagementDetailsUpdate(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//update MRS Ites Reports
export const updateMRSItesReports = createAsyncThunk(
    "adminApi/updateMRSItesReports",
    async (formBody, { dispatch }) => {
        const params = {
            LoginUserID: formBody.LoginUserID,
            UserID: formBody.UserID,
            GroupID: formBody.GroupID,
            HospitalName: formBody.HospitalName,
            ProviderName: formBody.ProviderName,
            ReportDate: formBody.ReportDate,
            ReportID: formBody.ReportID,
            ReportName: formBody.ReportName,
            TagNo: formBody.TagNo,
        };

        try {
            const resp = await axiosApi.post(apiConstants.reports?.updateMRSItesReports, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            const data = resp.data;

            dispatch(setUpdateMRSItesReports(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//archive User Management Details
export const usersManagementArchive = createAsyncThunk(
    "adminApi/UsersManagementArchive",
    async (formBody, { dispatch }) => {
        const params = {
            LoginUserID: formBody.LoginUserID,
            UserID: formBody.UserID,
        };

        try {
            const resp = await axiosApi.post(apiConstants.admin?.usersManagementArchive, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            const data = resp.data;

            dispatch(setUsersManagementArchive(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

//archive MRS Ites Reports
export const archiveMRSItesReports = createAsyncThunk(
    "adminApi/MRSItesReportsArchive",
    async (formBody, { dispatch }) => {

        try {
            const url = `${apiConstants.reports.archiveMRSItesReports}?Archivedby=${formBody.UserID}&ReportID=${formBody.ReportID}&LoginUserID=${formBody.LoginUserID}`;
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            const data = resp.data;
            dispatch(setArchiveMRSItesReports(data));
            return data;
        } catch (error) {
            console.log("archiveMRSItesReports error", error);
            throw error;
        }
    }
);
export const undoarchiveMRSItesReports = createAsyncThunk(
    "adminApi/MRSItesReportsArchive",
    async (formBody, { dispatch }) => {

        try {
            const url = `${apiConstants.reports.undoArchiveMRSItesReports}?ReportID=${formBody.ReportID}&UserID=${formBody.UserID}`;
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });
            const data = resp.data;
            dispatch(setArchiveMRSItesReports(data));
            return data;
        } catch (error) {
            console.log("archiveMRSItesReports error", error);
            throw error;
        }
    }
);
//end Chat
export const endChat = createAsyncThunk(
    "chatApi/endChat",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.post(apiConstants.chat?.endChat, formBody, {
            headers: { Authorization: `Bearer ${formBody.token}` }
        });
        return resp.data;
    }
);
//get Chat History
export const getChatHistory = createAsyncThunk(
    "chatApi/getChatHistory",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.get(apiConstants.chat?.GetACMEEnquiryMessages + "chatId=0" + "&loginUserId=" + formBody.user_id, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            // console.log("getChatHistory resp", resp);
            return resp.data;

        } catch (error) {
            console.log("getChatHistory error", error);
        }
    }
);

//get Reports For My Chat
export const getReportsForMyChat = createAsyncThunk(
    "chatApi/getReportsForMyChat",
    async (formBody, { dispatch }) => {
        console.log("getReportsForMyChat", formBody);
        const resp = await axiosApi.get(apiConstants.chat?.getReportsForMyChat + "userId=" + formBody.user_id, {
            headers: {
                Authorization: `Bearer ${formBody.token}`,
            },
        });
        return resp.data.Table;
    }
);


export const updateACMEReadMessage = createAsyncThunk(
    "chatApi/updateACMEReadMessage",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.post(apiConstants.chat?.UpdateACMEReadMessage, formBody, {
            headers: { Authorization: `Bearer ${formBody.token}` }
        });
        return resp.data;
    }
);

//Access Reports using share code
export const sharedReportsValidateCode = createAsyncThunk(
    "accessReportsApi/SharedReportsValidateCode",
    async (formBody, { dispatch }) => {
        const params = {
            share_code: formBody.share_code,
            email_address: formBody.email_address,
            date_of_birth: formBody.date_of_birth,
            usertype_id: formBody.usertype_id,

        };
        console.log("sharedReportsValidateCode params", params)

        try {
            const resp = await axiosApi.post(apiConstants.accessReports?.sharedReportsValidateCode, params);
            const data = resp.data;

            // dispatch(setSharedReportsValidateCode(data.menuItems));
            //  dispatch(setSharedReportsValidateCode(data));
            dispatch(setLoginDetails(data));
            dispatch(setMenuItem(data.menuItems));
            dispatch(setFamilyAccounts(data.family_accounts));
            dispatch(setToken(data.Token));
            dispatch(setSharedReportsValidateCode(data));
            return data;
        } catch (error) {
            // Handle error here if needed
            if (error.response) {
                console.log("Response data:", error.response.data);
                console.log("Response status:", error.response.status);
                console.log("Response headers:", error.response.headers);
            } else if (error.request) {
                // The request was made but no response was received
                console.log("Request:", error.request);
            } else {
                // Something happened in setting up the request that triggered an error
                console.log("Error:", error.message);
            }
            throw error;
        }
    }
);

export const updateWidgetSortOrder = createAsyncThunk(
    "loginApi/updateWidgetSortOrder",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.post(apiConstants.dashboard?.ProviderWidgetsManagementSortOrder, {
                UserId: formBody.UserId,
                DraggedWidgetId: formBody.DraggedWidgetId,
                DraggedWidgetSortOrder: formBody.DraggedWidgetSortOrder,
                TargetWidgetId: formBody.TargetWidgetId,
                TargetWidgetSortOrder: formBody.TargetWidgetSortOrder,
                LoggedInUserId: formBody.LoggedInUserId
            }, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });

            return resp.data;
        } catch (error) {
            console.log("updateWidgetSortOrder error", error);
            throw error;
        }
    }
);

export const getProviderWidgetsManagementMaster = createAsyncThunk(
    'loginApi/getProviderWidgetsManagementMaster',
    async (formBody, { rejectWithValue }) => {
        try {

            const response = await axiosApi.get(
                `${apiConstants.dashboard?.ProviderWidgetsManagementMasterGet}?UserID=${formBody.user_id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${formBody.token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            return response;
        } catch (error) {
            console.error('ProviderWidgetsManagementMasterGet API Error:', {
                status: error.response?.status,
                message: error.response?.data?.message || error.message,
                error: error
            });
            return rejectWithValue(error.response);
        }
    }
);

export const getProviderWidgetsManagement = createAsyncThunk(
    'loginApi/getProviderWidgetsManagement',
    async ({ user_id, login_user_id, token }, { rejectWithValue }) => {
        try {

            const response = await axiosApi.get(
                `${apiConstants.dashboard?.ProviderWidgetsManagementGet}?UserID=${user_id}&LoginUserID=${login_user_id}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const trendsGet = createAsyncThunk(
    "trendsApi/trendsGet",
    async (formBody, { dispatch }) => {
        const params = { UserID: formBody.user_id, StartDate: formBody.startDate, EndDate: formBody.endDate };


        try {
            const resp = await axiosApi.post(apiConstants.trends?.trendsGet, params,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            const data = resp.data.Table;

            //   dispatch(setTrendsGet(data));
            return data;
        } catch (error) {
            console.log("trendsGet error", error);
        }
    }
);

// Sticky Notes API thunks
export const saveStickyNotes = createAsyncThunk(
    "notes/saveStickyNotes",
    async (formBody, { getState }) => {
        try {
            const state = getState();
            const token = state.apiService.token;

            if (!token) {
                throw new Error('No authentication token available');
            }

            const params = {
                UserID: formBody.UserID,
                Notes: formBody.Notes,
                stickyID: formBody.stickyID,
                positionX: formBody.positionX,
                positionY: formBody.positionY
            };

            const resp = await axiosApi.post(apiConstants.notes.stickyNotesSave, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return resp.data;
        } catch (error) {
            console.error("Error saving sticky note:", error);
            throw error;
        }
    }
);

export const getStickyNotes = createAsyncThunk(
    "notes/getStickyNotes",
    async (formBody, { getState }) => {
        try {
            const state = getState();
            const token = state.apiService.token;

            if (!token) {
                throw new Error('No authentication token available');
            }

            const params = {
                LoginUserID: formBody.LoginUserID,
                Notes: formBody.Notes,
                stickyID: formBody.stickyID,
                positionX: formBody.positionX,
                positionY: formBody.positionY
            };

            const resp = await axiosApi.post(apiConstants.notes.stickyNotesGet, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return resp.data.Table;
        } catch (error) {
            console.error("Error getting sticky notes:", error);
            throw error;
        }
    }
);

export const deleteStickyNotes = createAsyncThunk(
    "notes/deleteStickyNotes",
    async (formBody, { getState }) => {
        try {
            const state = getState();
            const token = state.apiService.token;

            if (!token) {
                throw new Error('No authentication token available');
            }

            const params = {
                UserID: formBody.UserID,
                stickyID: formBody.stickyID
            };

            const resp = await axiosApi.post(apiConstants.notes.stickyNotesDelete, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });

            return resp.data;
        } catch (error) {
            console.error("Error deleting sticky note:", error);
            throw error;
        }
    }
);



export const InternalSharedReportOneTimeAccessCheck = createAsyncThunk(
    "accessReportsApi/InternalSharedReportOneTimeAccessCheck",
    async (formBody) => {
        const params = {
            loginUserId: formBody.loginUserId ?? formBody.LoginUserID,
            shareId: formBody.shareId ?? formBody.ShareID,
            validUpto: formBody.validUpto ?? formBody.validUpTo ?? '',
        };

        try {
            const resp = await axiosApi.post(
                apiConstants.reports?.InternalSharedReportOneTimeAccessCheck,
                params,
                { headers: { Authorization: `Bearer ${formBody.token}` } }
            );

            const data = resp.data;
            if (typeof data === 'boolean') {
                return data;
            }
            if (data === 'true') {
                return true;
            }
            if (data === 'false') {
                return false;
            }
            return Boolean(data);
        } catch (error) {
            console.error("InternalSharedReportOneTimeAccessCheck error", error);
            throw error;
        }
    }
);

export const InternalSharedReportAccessCheck = createAsyncThunk(
    "accessReportsApi/InternalSharedReportAccessCheck",
    async (formBody, { dispatch }) => {
        const params = {
            LoginUserID: formBody.LoginUserID,
            ShareToEmail: formBody.ShareToEmail,
            ShareNotes: formBody.ShareNotes,
            SharedToEmail: formBody.SharedToEmail
        };

        try {
            const resp = await axiosApi.post(
                apiConstants.reports?.InternalSharedReportAccessCheck,
                params,
                { headers: { Authorization: `Bearer ${formBody.token}` } }
            );
            return resp.data;
        } catch (error) {
            console.log("InternalSharedReportAccessCheck error", error);
            throw error;
        }
    }
);
export const InternalSharedReportSave = createAsyncThunk(
    "accessReportsApi/InternalSharedReportSave",
    async (formBody, { dispatch }) => {
        const params = {
            LoginUserID: formBody.LoginUserID,
            ShareToEmail: formBody.ShareToEmail,
            ShareNotes: formBody.ShareNotes,
            SharedToEmail: formBody.SharedToEmail
        };

        try {
            const resp = await axiosApi.post(
                apiConstants.reports?.InternalSharedReportSave,
                params,
                { headers: { Authorization: `Bearer ${formBody.token}` } } // Set token in headers
            );
            return resp.data;
        } catch (error) {
            console.log("InternalSharedReportSave error", error);
            throw error;
        }
    }
);
export const InternalSharedReportUpdateStatus = createAsyncThunk(
    "accessReportsApi/InternalSharedReportUpdateStatus",
    async (formBody, { dispatch }) => {
        const params = {
            ApprovedYN: formBody.ApprovedYN,
            IsApproved: formBody.IsApproved,
            LoginUserID: formBody.LoginUserID,
            ShareID: formBody.ShareID
        };

        try {
            const resp = await axiosApi.post(
                apiConstants.reports?.InternalSharedReportUpdateStatus,
                params,
                { headers: { Authorization: `Bearer ${formBody.token}` } }
            );
            return resp.data;
        } catch (error) {
            console.log("InternalSharedReportUpdateStatus error", error);
            throw error;
        }
    }
);

// Approve/Reject Family Account
export const FamilyAccountUpdateStatus = createAsyncThunk(
    "notification/FamilyAccountUpdateStatus",
    async (formData) => {
        // Use FamilyAccountID as required by backend
        const params = {
            ApprovedYN: formData.IsApproved, // Map IsApproved to ApprovedYN
            IsApproved: formData.IsApproved,
            LoginUserID: formData.LoginUserID,
            FamilyAccountID: formData.FamilyAccountID
        };
        const resp = await axiosApi.post(apiConstants.notifications?.FamilyAccountUpdateStatus, params, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });
        return resp.data;
    }
);

export const notificationsRead = createAsyncThunk(
    "notifications/notificationsRead",
    async (formData) => {

        const params = {
            UserID: formData.user_id,
            NotificationID: formData.notification_id
        };
        const resp = await axiosApi.post(apiConstants.notifications?.notificationsRead, params, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });
        return resp.data;
    }
);

export const setNotificationPreference = createAsyncThunk(
    "notifications/setNotificationPreference",
    async (formData, { dispatch }) => {
        const params = {
            user_id: formData.user_id,
            preference_type_id: formData.preference_type_id,
        };
        const resp = await axiosApi.post(apiConstants.notifications?.notificationPreference, params, {
            headers: { Authorization: `Bearer ${formData.token}` },
        });
        dispatch(updateNotificationPreferenceState(formData.preference_type_id));
        return resp.data;
    }
);

export const registerPushSubscription = createAsyncThunk(
    "notifications/registerPushSubscription",
    async (formData) => {
        const params = {
            user_id: formData.user_id,
            endpoint: formData.endpoint,
            p256dh: formData.p256dh,
            auth: formData.auth,
            user_agent: formData.user_agent,
            device_label: formData.device_label,
        };
        const resp = await axiosApi.post(apiConstants.notifications?.pushSubscriptions, params, {
            headers: { Authorization: `Bearer ${formData.token}` },
        });
        return resp.data;
    }
);

export const NotificationsReadAll = createAsyncThunk(
    "notifications/NotificationsReadAll",
    async (formData) => {

        const params = {
            UserID: formData.user_id,
            is_important_notifications: formData.is_important_notifications
        };

        const resp = await axiosApi.post(apiConstants.notifications?.NotificationsReadAll, params, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });
        return resp.data;
    }
);
// export const NotificationsGet = createAsyncThunk(
//     "notifications/NotificationsGet",
//     async (formData) => {
//             console.log("NotificationsGet", formData);
//             const params = {
//             UserID: formData.user_id
//         };
//       const resp = await axiosApi.get(apiConstants.notifications?.NotificationsGet, params, {
//         headers: { Authorization: `Bearer ${formData.token}` }
//       });
//       return resp.data.Table;
//     }
// );
export const NotificationsGet = createAsyncThunk(
    "notifications/NotificationsGet",
    async (formData) => {

        const params = {
            UserID: formData.user_id,
            Token: formData.token,
            is_important_notifications: formData.is_important_notifications,
            is_displayed: formData.is_displayed,
            approved_yn: formData.approved_yn,
            family_account_id: formData.family_account_id,
            share_id: formData.share_id,
            report_id: formData.report_id,
        };
        // Build the URL with query param
        const url = `${apiConstants.notifications?.NotificationsGet}?UserID=${formData.user_id}`;
        // Make a GET request, add token in headers if needed
        const resp = await axiosApi.get(url, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });
        return resp.data.Table;
    }
);

export const editReport = createAsyncThunk(
    "editReportApi/editReport",
    async (formBody, { dispatch }) => {

        try {
            const resp = await axiosApi.post(apiConstants.reports.updateMRSItesReports, formBody);
            return resp.data;
        } catch (error) {
            console.log("editReport error", error);
            throw error;
        }
    }
);

export const getPatientConversationList = createAsyncThunk(
    "conversation/getPatientConversationList",
    async (formData) => {


        const resp = await axiosApi.get(apiConstants.conversation?.getPatientConversationList + 'loginUserId=' + formData.user_id + '&searchKey=' + formData.searchKey, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });
        console.log("getPatientConversationList response", resp);
        return resp.data;
    }
);

export const getProvidermessages = createAsyncThunk(
    "conversation/getProvidermessages",
    async (formData) => {

        const resp = await axiosApi.get(apiConstants.conversation?.getProvidermessages + "loginUserId=" + formData.user_id + "&chatId=" + formData.chatId, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });

        return resp.data;
    }
);
export const sendMessage = createAsyncThunk(
    "conversation/sendMessage",
    async (formData) => {

        const resp = await axiosApi.post(apiConstants.conversation?.sendMessage, formData, {
            headers: { Authorization: `Bearer ${formData.token}` }
        });
        return resp.data;
    }
);

export const NotificationsShown = createAsyncThunk(
    "notifications/NotificationsShown",
    async (formData) => {

        const params = {
            UserID: formData.user_id,
            NotificationID: formData.notification_id
        };
        const resp = await axiosApi.post(apiConstants.notifications?.NotificationsShown, params, {

            headers: { Authorization: `Bearer ${formData.token}` }
        });
        return resp.data;
    }
);

// Fetch locations
export const getLocations = createAsyncThunk(
    "dashboardApi/getLocations",
    async ({ user_id, token }, { rejectWithValue }) => {
        try {
            const resp = await axiosApi.get(`/Locations/LocationGet?LocationID=0`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return resp.data.Table || [];
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Add new location
export const addLocation = createAsyncThunk(
    "dashboardApi/addLocation",
    async ({ user_id, location_name, token }, { rejectWithValue }) => {
        try {
            const resp = await axiosApi.post(`/Locations/LocationSave`, {
                LocationName: location_name,
                UserID: user_id,
                LocationID: 0
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return resp.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

// Remove location replace with Location Name
export const removeLocation = createAsyncThunk(
    "dashboardApi/removeLocation",
    async ({ user_id, location_name, token }, { rejectWithValue }) => {
        try {
            const resp = await axiosApi.post(`/Locations/LocationsInactive`, {
                locationName: location_name,
                UserID: user_id
            }, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return resp.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const saveReportDocumentChat = createAsyncThunk(
    "document/saveReportDocument",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosApi.post(
                apiConstants.conversation.saveReportDocument,
                formData,
                {
                    headers: {
                        'Authorization': `Bearer ${formData.get('token')}`,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            );
            return response;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);

export const getAttachmentbyFileId = createAsyncThunk(
    "document/getAttachmentbyFileId",
    async (formData, { rejectWithValue }) => {
        try {
            const response = await axiosApi.post(apiConstants.chat.getAttachmentbyFileId, formData, {
                headers: { Authorization: `Bearer ${formData.token}` },
                responseType: 'blob'
            });

            return response.data;
        } catch (error) {
            if (error.response) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);

export const announcementsDelete = createAsyncThunk(
    "dashBoardApi/announcementsDelete",
    async (formBody, { dispatch, rejectWithValue }) => {
        console.log(formBody, 'formBody delete');
        const params = {
            announcement_id: formBody.announcement_id,
            deleted_by: formBody.deleted_by,
        };
        console.log(params, 'params delete');
        try {
            const resp = await axiosApi.post(apiConstants.blog.announcementDelete, params, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                    'Content-Type': 'application/json',
                },
            });
            console.log(resp, 'resp delete');

            // Check if the response indicates success
            if (resp.status === 200 || resp.status === 201) {
                dispatch(setAnnouncementsDelete(resp.data));
                return resp.data;
            } else {
                throw new Error(`Server responded with status: ${resp.status}`);
            }
        } catch (error) {
            console.log(error, "error for announcementsDelete");
            const errorMessage = error.response?.data?.message ||
                error.response?.data?.error ||
                error.message ||
                'Delete operation failed';
            return rejectWithValue(errorMessage);
        }
    }
);

export const announcementsCommentsSave = createAsyncThunk(
    "dashBoardApi/announcementsCommentsSave",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.announcementsCommentsSave, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for announcementsCommentsSave");
            throw error;
        }
    }
);

export const announcementsReactionsSave = createAsyncThunk(
    "dashBoardApi/announcementsReactionsSave",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.dashboard.announcementsReactionsSave, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for announcementsReactionsSave");
            throw error;
        }
    }
);

export const announcementsCommentsGet = createAsyncThunk(
    "dashBoardApi/announcementsCommentsGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.dashboard.announcementsCommentsGet, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for announcementsCommentsGet");
            throw error;
        }
    }
);
export const CreateBlogReaction = createAsyncThunk(
    "dashBoardApi/CreateBlogReaction",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.blog.CreateBlogReaction, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for CreateBlogReaction");
            throw error;
        }
    }
);
export const GetBlogCommentsReactions = createAsyncThunk(
    "dashBoardApi/GetBlogCommentsReactions",
    async (formBody, { dispatch }) => {
        try {
            // Build the URL with query params
            const url = `${apiConstants.blog.GetBlogCommentsReactions}?blogId=${formBody.blogId}&loggedinUserId=${formBody.loggedinUserId}`;
            const resp = await axiosApi.get(url, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for GetBlogCommentsReactions");
            throw error;
        }
    }
);
export const GetACMEEnquiryMessages = createAsyncThunk(
    "dashBoardApi/GetACMEEnquiryMessages",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.get(apiConstants.chat.GetACMEEnquiryMessages, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for GetACMEEnquiryMessages");
            throw error;
        }
    }
);

// Ask ACME – Document Assistant APIs
export const documentAssistantAsk = createAsyncThunk(
    "documentAssistant/Ask",
    async (formBody) => {
        const { token, UserID, DocumentID, Question, signal } = formBody;
        const sessionId =
            formBody.sessionId ?? formBody.SessionId ?? formBody.SessionID ?? null;

        const body = {
            UserID,
            DocumentID,
            Question,
        };
        // Continue the same chat when SessionID is present; omit on first question.
        if (sessionId != null && sessionId !== '') {
            const sid = Number(sessionId);
            body.SessionID = Number.isFinite(sid) ? sid : sessionId;
        }

        const resp = await axiosApi.post(
            apiConstants.documentAssistant.ask,
            body,
            { headers: { Authorization: `Bearer ${token}` }, signal }
        );
        return resp.data;
    }
);

export const documentAssistantChatHistoryGet = createAsyncThunk(
    "documentAssistant/ChatHistoryGet",
    async (formBody) => {
        const params = new URLSearchParams();
        params.set('UserId', String(formBody.UserId ?? formBody.userId ?? formBody.UserID));

        const sessionId =
            formBody.sessionId ?? formBody.SessionId ?? formBody.SessionID ?? null;
        if (sessionId != null && sessionId !== '') {
            params.set('sessionId', String(sessionId));
        }

        if (formBody.DocumentID != null && formBody.DocumentID !== '') {
            params.set('DocumentID', String(formBody.DocumentID));
        } else if (formBody.documentId != null && formBody.documentId !== '') {
            params.set('DocumentID', String(formBody.documentId));
        }

        const resp = await axiosApi.get(
            `${apiConstants.documentAssistant.chatHistoryGet}${params.toString()}`,
            { headers: { Authorization: `Bearer ${formBody.token}` } }
        );
        return resp.data;
    }
);

export const documentAssistantChatHistoryDelete = createAsyncThunk(
    "documentAssistant/ChatHistoryDelete",
    async (formBody, { rejectWithValue }) => {
        try {
            const resp = await axiosApi.post(
                apiConstants.documentAssistant.chatHistoryDelete,
                {
                    UserId: formBody.UserId,
                    SessionId: formBody.SessionId,
                    DocumentID: formBody.DocumentID,
                },
                { headers: { Authorization: `Bearer ${formBody.token}` } }
            );
            return resp.data;
        } catch (error) {
            const apiData = error?.response?.data;
            return rejectWithValue(apiData ?? error.message);
        }
    }
);

export const documentAssistantChatSessionRename = createAsyncThunk(
    "documentAssistant/ChatSessionRename",
    async (formBody, { rejectWithValue }) => {
        try {
            const userId = formBody.UserID ?? formBody.UserId ?? formBody.userId;
            const sessionId = formBody.SessionID ?? formBody.SessionId ?? formBody.sessionId;
            const sessionTitle =
                formBody.SessionTitle ?? formBody.sessionTitle ?? formBody.title ?? '';

            const resp = await axiosApi.post(
                apiConstants.documentAssistant.chatSessionRename,
                {
                    UserID: userId,
                    SessionID: sessionId,
                    SessionTitle: sessionTitle,
                },
                { headers: { Authorization: `Bearer ${formBody.token}` } }
            );
            return resp.data;
        } catch (error) {
            const apiData = error?.response?.data;
            return rejectWithValue(apiData ?? error.message);
        }
    }
);

export const documentAssistantUpload = createAsyncThunk(
    "documentAssistant/Upload",
    async (formBody, { rejectWithValue }) => {
        const { token, filename, filepath, file, mode, signal } = formBody;
        const resolvedUserId = Number(
            formBody.userId ?? formBody.UserId ?? formBody.UserID ?? formBody.user_id
        );
        const resolvedReportId = Number(
            formBody.reportId ?? formBody.ReportId ?? formBody.ReportID ?? formBody.report_id
        );
        const hasReportId = Number.isFinite(resolvedReportId) && !Number.isNaN(resolvedReportId);

        if (!resolvedUserId || Number.isNaN(resolvedUserId)) {
            return rejectWithValue('userId is required');
        }
        if (!filename) {
            return rejectWithValue('filename is required');
        }

        const resolvedFilePath = filepath || filename;
        const uploadMode = mode || (file ? 'multipart' : 'json');

        try {
            // BE contract: userId, filename, filepath, ReportID (from reports list)
            if (uploadMode === 'json') {
                const body = {
                    userId: resolvedUserId,
                    filename,
                    filepath: resolvedFilePath,
                };
                if (hasReportId) {
                    body.ReportID = resolvedReportId;
                }
                const resp = await axiosApi.post(apiConstants.documentAssistant.upload, body, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    signal,
                });
                return resp.data;
            }

            const data = new FormData();
            data.append('userId', String(resolvedUserId));
            data.append('filename', filename);
            data.append('filepath', resolvedFilePath);
            if (hasReportId) {
                data.append('ReportID', String(resolvedReportId));
            }
            if (file) {
                data.append('file', file, filename);
            }
            const resp = await axiosApi.post(apiConstants.documentAssistant.upload, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json',
                },
                signal,
            });
            return resp.data;
        } catch (error) {
            if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') {
                throw error;
            }
            const apiData = error?.response?.data;
            const message =
                (typeof apiData === 'string' && apiData) ||
                apiData?.Message ||
                apiData?.message ||
                apiData?.title ||
                error.message ||
                'DocumentAssistantUpload failed';
            return rejectWithValue(message);
        }
    }
);
export const InternalSharedReportsGet = createAsyncThunk(
    "dashBoardApi/InternalSharedReportsGet",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.reports.InternalSharedReportUsersGet, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for InternalSharedReportsGet");
            throw error;
        }
    }
);

export const createBlogComment = createAsyncThunk(
    "dashBoardApi/createBlogComment",
    async (formBody, { dispatch }) => {
        try {
            const resp = await axiosApi.post(apiConstants.blog.createBlogComment, formBody, {
                headers: {
                    Authorization: `Bearer ${formBody.token}`,
                },
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for createBlogComment");
            throw error;
        }
    }
);

export const sendEmail = createAsyncThunk(
    "emails/sendEmail",
    async (formBody, { dispatch }) => {
        try {
            const { token, ...requestBody } = formBody;
            const resp = await axiosApi.post(apiConstants.emails.sendEmail, requestBody, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return resp.data;
        } catch (error) {
            console.log(error, "error for sendEmail");
            throw error;
        }
    }
);
 export const downloadMultipleReports = createAsyncThunk(
    "emails/downloadMultipleReports",
    async (formBody, { dispatch }) => {
        try {
            const { token, reportIds, userId } = formBody || {};
            const resp = await axiosApi.get(apiConstants.emails.downloadMultipleReports, {
                params: { reportIds, userId },
                headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/zip' },
                responseType: 'blob',
            });
            const contentDisposition =
                resp.headers?.['content-disposition'] ||
                resp.headers?.['Content-Disposition'] ||
                (typeof resp.headers?.get === 'function' ? resp.headers.get('content-disposition') : null) ||
                (typeof resp.request?.getResponseHeader === 'function' ? resp.request.getResponseHeader('content-disposition') : null);

            const buildDefaultZipName = () => {
                const d = new Date();
                const pad = (n) => String(n).padStart(2, '0');
                const ts =
                    d.getFullYear().toString() +
                    pad(d.getMonth() + 1) +
                    pad(d.getDate()) +
                    pad(d.getHours()) +
                    pad(d.getMinutes()) +
                    pad(d.getSeconds());
                return `Reports_${ts}.zip`;
            };

            let fileName = buildDefaultZipName();
            if (contentDisposition) {
                const utf8Match = contentDisposition.match(/filename\*=\s*(?:[^']*'[^']*')?([^;\r\n]+)/i);
                const plainMatch = contentDisposition.match(/(?:^|;)\s*filename\s*=\s*"?([^";\r\n]+)"?/i);
                if (utf8Match && utf8Match[1]) {
                    const raw = utf8Match[1].trim().replace(/^"+|"+$/g, '');
                    try { fileName = decodeURIComponent(raw); } catch (e) { fileName = raw; }
                } else if (plainMatch && plainMatch[1]) {
                    fileName = plainMatch[1].trim();
                }
            }
            console.log('downloadMultipleReports → resolved fileName:', fileName);

            const zipBlob = resp.data instanceof Blob
                ? resp.data
                : new Blob([resp.data], { type: 'application/zip' });

            const blobUrl = window.URL.createObjectURL(zipBlob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(blobUrl);

            return { fileName, status: resp.status };
        } catch (error) {
            console.log(error, "error for downloadMultipleReports");
            throw error;
        }
    }
);

export const getCalendarEventsCatgories = createAsyncThunk(
    "dashBoardApi/getCalendarEventsCatgories",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.get(apiConstants.calendar.getCalendarEventsCatgories, {
            headers: { Authorization: `Bearer ${formBody.token}` },
        });
        return resp.data;
    }
);

export const getCalendarTimeEvents = createAsyncThunk(
    "dashBoardApi/getCalendarTimeEvents",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.get(apiConstants.calendar.getCalendarTimeEvents, {
            headers: { Authorization: `Bearer ${formBody.token}` },
        });
        return resp.data;
    }
);

export const saveCalendarTimeEvent = createAsyncThunk(
    "dashBoardApi/saveCalendarTimeEvent",
    async (formBody, { dispatch }) => {
        const resp = await axiosApi.post(apiConstants.calendar.saveCalendarTimeEvent, formBody, {
            headers: { Authorization: `Bearer ${formBody.token}` },
        });
        return resp.data;
    }
);

export const getCalenderEvents = createAsyncThunk(
    "calendar/GetPatientReminders",
    async (formBody, { dispatch }) => {
        const params = {
            UserID: formBody.userId
        };
        try {
            const resp = await axiosApi.get(
                apiConstants.calendar.getCalenderEvents,
                {
                    params,
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            return resp.data;
        } catch (error) {
            console.log(error, "error for getCalenderEvents");
            throw error;
        }
    }
);

export const deleteReminder = createAsyncThunk(
    "calendar/deleteReminder",
    async (formBody, { dispatch }) => {
        const payload = {
            UserId: formBody.userId,
            Id: formBody.reminderId
        };
        try {
            const resp = await axiosApi.post(
                apiConstants.calendar.deleteReminder,
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${formBody.token}`,
                    },
                }
            );
            return resp.data;
        } catch (error) {
            console.log(error, "error for deleteReminder");
            throw error;
        }
    }
);

export const apiService = createSlice({
    name: "apiService",
    initialState: {
        loginUserDetails: [], // Login User
        resetUserPassword: [], // Reset User Password
        menuItem: [], // Menu Item,
        familyAccounts: [], //Family Accounts
        selectedFamilyMember: null, // Selected Family Member
        registerUserDetails: [], //Register User      
        token: [], //Token for Patient or Doctor
        medicationData: [], //Medication Data
        widgetsData: [], //Widgets Data
        allergiesData: [], //Allergies Data
        getReportsData: [], //Reports Data
        UserTypesGet: [], //SignUp User
        IinternalSharedReportsFromOthers: [], // with you
        InternalSharedReportsToOthers: [], // By you
        InternalSharedReportsFromOthersComplete: [], // Approve Access
        ReportCategoriesGet: [],// Share Every where
        SharedReportValidityGet: [], // Validity
        internalSharedReportRevoke: [], // Internal Shared Report Revoke
        getMRSItesReports: [], // MRS Ites Reports
        medicalHistoryData: [], //Medical History Data
        vaccinationData: [], //Vaccination Data
        providerNotesData: [], //Provider Notes Data
        userAppointmentsData: [], //Provider Notes Data
        UsersWidgetsAdd: [], //Provider Notes Data
        usersWidgetsDelete: [], //Provider Notes Data
        shareReportQRCodeURL: [], // QR code
        sharedReportGeneratecodeGet: [],//shared Report Generate Code
        receiptsData: [], //Provider Notes Data
        announcementsSave: [], //announcements Save
        announcementsGet: [], //announcements Get
        applicationAnnouncements: [], //application announcements Get
        getUserRiskAnalysisData: [], //getUser Risk Analysis Data
        extractRiskCalculatorData: [], //extract Risk Calculator Data

        saveReportDocumentStatus: 'idle',
        saveReportDocumentError: null,
        getMedicationatDashboard: [], //get Medication at Dashboard
        usersDetailsGet: [], //users Details Get
        familyRelationsGet: [], //family Relations Get
        familyMembersUsersGet: [], //family Members Users Get
        familyAccountsGetNew: [], //family Accounts Get New
        userDetailsUpdate: [], //user Details Update
        familyAccountDelete: [], //family Account Delete
        familyAccountCreate: [], //family Account Create
        notificationsGet: [], //notifications Get
        notificationsShown: [], //notifications Shown
        getUserDetailsGet: [], //getUser Details Get
        getUsersManagementReportsGet: [], //get Users Management Reports Get
        getUserManagementDetailsGet: [], //getUser Management Details Get
        sharedReportsValidateCode: [], //shared Reports Validate Code
        providerWidgetsManagement: [], // Add this new state
        stickyNotes: [], // Add sticky notes state
        stickyNotesStatus: 'idle',
        stickyNotesError: null,
        getGendersList: [], //Genders List
        getRolesList: [], //Roles List
        getSubscriptionsList: [], // Subscriptions List
        usersManagementDetailsUpdate: [], //users Management Details Update
        usersManagementArchive: [], //users Management Archive
        updateMRSItesReports: [], //update MRS Ites Reports
        archiveMRSItesReports: [], //archive MRS Ites Reports
        validateUserEmail: [], //validate User Email
        generateOneTimeLoginLink: [], //generate One Time Login Link
        resetPasswordEmailNotification: [], //reset Password Email Notification
        updatePassword: [], //update Password
        userPhotoUpload: [], //user Photo Upload
        createBlogComment: [], //create Blog Comment    
        announcementsDelete: [], //announcements Delete
        announcementsUpdate: [], //announcements Update
    },

    reducers: {
        setLoginDetails: (state, action) => {
            state.login = action.payload;
            state.token = action.payload?.Token || action.payload?.token || action.payload?.access_token;

        },
        updateNotificationPreferenceState: (state, action) => {
            if (state.login) state.login.notification_preference = action.payload;
        },
        setRegisterDetails: (state, action) => {
            //Set Registered User Details
            state.register = action.payload;
        },
        setMenuItem: (state, action) => {
            //Set Available Doctors List
            state.menuItem = action.payload;
        },
        setFamilyAccounts: (state, action) => {
            //Set Available Doctors List
            state.familyAccounts = action.payload;
        },
        setSelectedFamilyMember: (state, action) => {
            //Set Selected Family Member
            state.selectedFamilyMember = action.payload;
        },
        setToken: (state, action) => {
            //Set Token
            state.token = action.payload;
        },
        setMedicationData: (state, action) => {
            //Set Token
            state.medicationData = action.payload;
        },
        setWidgetsData: (state, action) => {
            state.widgetsData = action.payload;
        },
        setAllergiesData: (state, action) => {
            state.allergiesData = action.payload;
        },
        setUserTypes: (state, action) => {
            state.UserTypesGet = action.payload;
        },
        setSharedReportsFromOthers: (state, action) => {
            state.IinternalSharedReportsFromOthers = action.payload;
        },
        setSharedReportsToOthers: (state, action) => {
            state.InternalSharedReportsToOthers = action.payload;
        },
        setSharedReportsFromOthersComplete: (state, action) => {
            state.InternalSharedReportsFromOthersComplete = action.payload;
        },
        setSharedReportsReportCategoriesGet: (state, action) => {
            state.ReportCategoriesGet = action.payload;
        },
        setSharedReportValidityGet: (state, action) => {
            state.SharedReportValidityGet = action.payload;
        },
        setGetMRSItesReports: (state, action) => {
            state.getMRSItesReports = action.payload;
        },
        setMedicalHistoryData: (state, action) => {
            state.medicalHistoryData = action.payload;
        },
        setVaccinationData: (state, action) => {
            state.vaccinationData = action.payload;
        },
        setProviderNotesData: (state, action) => {
            state.providerNotesData = action.payload;
        },
        setUserAppointmentsData: (state, action) => {
            state.userAppointmentsData = action.payload;
        },
        setUsersWidgetsAdd: (state, action) => {
            state.UsersWidgetsAdd = action.payload;
        },
        setUsersWidgetsDelete: (state, action) => {
            state.usersWidgetsDelete = action.payload;
        },
        setReportsData: (state, action) => {
            state.getReportsData = action.payload;
        },
        // setSharedReportGeneratecodeGet: (state, action) => {
        //     state.sharedReportGeneratecodeGet = action.payload;
        // },
        setShareReportQRCodeURL: (state, action) => {
            state.shareReportQRCodeURL = action.payload;
        },
        setReceiptsData: (state, action) => {
            state.receiptsData = action.payload;
        },
        setAnnouncementsSave: (state, action) => {
            state.announcementsSave = action.payload;
        },
        setAnnouncementsGet: (state, action) => {
            state.announcementsGet = action.payload;
        },
        setApplicationAnnouncements: (state, action) => {
            state.applicationAnnouncements = action.payload;
        },
        setGetUserRiskAnalysisData: (state, action) => {
            state.getUserRiskAnalysisData = action.payload;
        },
        setExtractRiskCalculatorData: (state, action) => {
            state.extractRiskCalculatorData = action.payload;
        },
        setGetMediacatiopnsatDashboard: (state, action) => {
            state.getMedicationatDashboard = action.payload;
        },
        setUsersDetailsGet: (state, action) => {
            state.usersDetailsGet = action.payload;
        },
        setFamilyRelationsGet: (state, action) => {
            state.familyRelationsGet = action.payload;
        },
        setFamilyMembersUsersGet: (state, action) => {
            state.familyMembersUsersGet = action.payload;
        },
        setFamilyAccountsGetNew: (state, action) => {
            state.familyAccountsGetNew = action.payload;
        },
        setUserDetailsUpdate: (state, action) => {
            state.userDetailsUpdate = action.payload;
        },
        setFamilyAccountDelete: (state, action) => {
            state.familyAccountDelete = action.payload;
        },
        setFamilyAccountCreate: (state, action) => {
            state.familyAccountCreate = action.payload;
        },
        setNotificationsGet: (state, action) => {
            state.notificationsGet = action.payload;
        },
        setNotificationsShown: (state, action) => {
            state.notificationsShown = action.payload;
        },
        setGetUserDetailsGet: (state, action) => {
            state.getUserDetailsGet = action.payload;
        },
        setGetUsersManagementReportsGet: (state, action) => {
            state.getUsersManagementReportsGet = action.payload;
        },
        setGetUserManagementDetailsGet: (state, action) => {
            state.getUserManagementDetailsGet = action.payload;
        },
        setSharedReportsValidateCode: (state, action) => {
            state.sharedReportsValidateCode = action.payload;
        },

        setProviderWidgetsManagement: (state, action) => {
            state.providerWidgetsManagement = action.payload;
        },
        setStickyNotes: (state, action) => {
            state.stickyNotes = action.payload;
        },
        setGetGendersList: (state, action) => {
            state.getGendersList = action.payload;
        },
        setGetRolesList: (state, action) => {
            state.getRolesList = action.payload;
        },
        setGetSubscriptionsList: (state, action) => {
            state.getSubscriptionsList = action.payload;
        },
        setUsersManagementDetailsUpdate: (state, action) => {
            state.usersManagementDetailsUpdate = action.payload;
        },
        setUsersManagementArchive: (state, action) => {
            state.usersManagementArchive = action.payload;
        },
        setUpdateMRSItesReports: (state, action) => {
            state.updateMRSItesReports = action.payload;
        },
        setArchiveMRSItesReports: (state, action) => {
            state.archiveMRSItesReports = action.payload;
        },
        setValidateUserEmail: (state, action) => {
            state.validateUserEmail = action.payload;
        },
        setGenerateOneTimeLoginLink: (state, action) => {
            state.generateOneTimeLoginLink = action.payload;
        },
        setResetPasswordEmailNotification: (state, action) => {
            state.resetPasswordEmailNotification = action.payload;
        },
        setUpdatePassword: (state, action) => {
            state.updatePassword = action.payload;
        },
        setUserPhotoUpload: (state, action) => {
            state.userPhotoUpload = action.payload;
        },
        setSharedReportGeneratecodeGet: (state, action) => {
            state.sharedReportGeneratecodeGet = action.payload;
        },
        setInternalSharedReportRevoke: (state, action) => {
            state.internalSharedReportRevoke = action.payload;
        },
        setResetUserPassword: (state, action) => {
            state.resetUserPassword = action.payload;
        },
        setAnnouncementsDelete: (state, action) => {
            state.announcementsDelete = action.payload;
        },
        setAnnouncementsUpdate: (state, action) => {
            state.announcementsUpdate = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(saveReportDocument.pending, (state) => {
                state.saveReportDocumentStatus = 'loading';
                state.saveReportDocumentError = null;
            })
            .addCase(saveReportDocument.fulfilled, (state, action) => {
                state.saveReportDocumentStatus = 'succeeded';
                state.saveReportDocumentError = null;
            })
            .addCase(saveReportDocument.rejected, (state, action) => {
                state.saveReportDocumentStatus = 'failed';
                state.saveReportDocumentError = action.payload || action.error.message;
            })
            .addCase(saveStickyNotes.pending, (state) => {
                state.stickyNotesStatus = 'loading';
            })
            .addCase(saveStickyNotes.fulfilled, (state, action) => {
                state.stickyNotesStatus = 'succeeded';
                if (Array.isArray(action.payload)) {
                    state.stickyNotes = action.payload;
                } else if (action.payload?.Table && Array.isArray(action.payload.Table)) {
                    state.stickyNotes = action.payload.Table;
                } else {
                    state.stickyNotes = [];
                }
            })
            .addCase(saveStickyNotes.rejected, (state, action) => {
                state.stickyNotesStatus = 'failed';
                state.stickyNotesError = action.error.message;
            })
            .addCase(getStickyNotes.fulfilled, (state, action) => {
                if (Array.isArray(action.payload)) {
                    state.stickyNotes = action.payload;
                } else if (action.payload?.Table && Array.isArray(action.payload.Table)) {
                    state.stickyNotes = action.payload.Table;
                } else {
                    state.stickyNotes = [];
                }
            })
            .addCase(deleteStickyNotes.fulfilled, (state, action) => {
                if (!Array.isArray(state.stickyNotes)) {
                    state.stickyNotes = [];
                }
                state.stickyNotes = state.stickyNotes.filter(note => note.sticky_id !== action.payload.sticky_id);
            })
            .addCase(createBlogComment.fulfilled, (state, action) => {
                state.createBlogComment = action.payload;
            })
            .addCase(createBlogComment.rejected, (state, action) => {
                state.createBlogCommentError = action.error.message;
            })
        // .addCase(getApplicationAnnouncements.fulfilled, (state, action) => {
        //     state.applicationAnnouncements = action.payload || [];
        // });
    }
});



export const {
    setLoginDetails,
    setRegisterDetails,
    setMenuItem,
            setFamilyAccounts,
        setSelectedFamilyMember,
    setToken,
    setMedicationData,
    setWidgetsData,
    setAllergiesData,
    setUserTypes,
    setSharedReportsFromOthers,
    setSharedReportsToOthers,
    setSharedReportsFromOthersComplete,
    setSharedReportsReportCategoriesGet,
    setSharedReportValidityGet,
    setGetMRSItesReports,
    setMedicalHistoryData,
    setVaccinationData,
    setProviderNotesData,
    setUserAppointmentsData,
    setUsersWidgetsAdd,
    setUsersWidgetsDelete,
    setReportsData,
    setReceiptsData,
    // setsharedReportGeneratecodeGet,
    setShareReportQRCodeURL,
    setAnnouncementsSave,
    setAnnouncementsGet,
    setApplicationAnnouncements,
    setGetUserRiskAnalysisData,
    setExtractRiskCalculatorData,
    setGetMediacatiopnsatDashboard,
    setUsersDetailsGet,
    setFamilyRelationsGet,
    setFamilyMembersUsersGet,
    setFamilyAccountsGetNew,
    setUserDetailsUpdate,
    setFamilyAccountDelete,
    setFamilyAccountCreate,
    setNotificationsGet,
    setNotificationsShown,
    setGetUserDetailsGet,
    setGetUsersManagementReportsGet,
    setGetUserManagementDetailsGet,
    setSharedReportsValidateCode,
    setProviderWidgetsManagement,
    setStickyNotes,
    setGetGendersList,
    setGetRolesList,
    setGetSubscriptionsList,
    setUsersManagementDetailsUpdate,
    setUsersManagementArchive,
    setUpdateMRSItesReports,
    setArchiveMRSItesReports,
    setValidateUserEmail,
    setGenerateOneTimeLoginLink,
    setResetPasswordEmailNotification,
    setUpdatePassword,
    setUserPhotoUpload,
    setSharedReportGeneratecodeGet,
    setInternalSharedReportRevoke,
    setResetUserPassword,
    setCreateBlogComment,
    setAnnouncementsDelete,
    setAnnouncementsUpdate,
    updateNotificationPreferenceState,
} = apiService.actions;

export default apiService.reducer;